import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

export function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {value === index && (
                <Box  sx={{ p: 0, m: 0 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
